import React, { useEffect, useState } from 'react';
import './ContactUsResponses.scss';
import { AiFillDelete, AiFillCloseCircle } from 'react-icons/ai';
import { SiGooglemessages } from 'react-icons/si';
import { MdEmail } from 'react-icons/md';
import firebase from '../../../FirebaseConfig/firebase';
import { useStateValue } from '../../../services/ContextProvider';
import { getContactUsResponses } from '../../../services/DashboardService';
import moment from 'moment';

const ContactUsResponses = () => {
    const db = firebase.firestore();
    const [checkResponses, setCheckResponses] = useState(false);
    const { responseState, responseDispatch } = useStateValue();
    const [responses, setResponses] = useState(responseState || []);

    //useEffect(() => {
    //    db.collection('contactus').get().then((snapshot) => {
    //        const s = snapshot.docs.map((doc => {
    //            return {
    //                id: doc.id,
    //                ...doc.data()
    //            };
    //        }));

    //        setResponses(s);
    //        console.log(s);
    //    });

    //}, [checkResponses]);

    useEffect(async () => {
        if (responseState.resList.length === 0) {
            await getContactUsResponses(responseDispatch, responseState.resList);
        }
    }, [checkResponses]);

    useEffect(() => {
        if (responseState.resList.length !== 0) {
            setResponses(responseState);
        }
        if (responses.resList && responses.resList.length === 1) {
            setResponses(responseState);
        }
    }, [responseState]);

    const deleteResponse = (id) => {
        db.collection('contactus')
            .doc(id)
            .delete()
            .then(() => {
                //setCheckResponses(!checkResponses);
                let tempResList = responses.resList.filter(res => res.id != id);
                console.log(tempResList);
                //setResponses(tempResList);
                console.log('Document successfully deleted!');
            })
            .catch((error) => {
                console.error('Error removing document: ', error);
            });
    };

    return (
        <div>
            <div class='m-4'>
                <h4 class='display-4 contactus-title'>
                    <SiGooglemessages />
                    &nbsp;&nbsp; <b>Contact Us Responses</b>
                    <span class='badge badge-danger rounded-circle notification'>
                        {responseState.resList.length}
                    </span>
                </h4>
            </div>
            <hr />
            <div className='contactus-content'>
                {responses.resList.map((response, index) => {
                    return (
                        <div key={index}>
                            <div class='row'>
                                <div class='col-xs-12 col-sm-6 col-md-6'>
                                    <div class='card m-1 p-0 mx-auto'>
                                        <div class='m-2 pb-0 pl-0 ml-0 pt-3 row'>
                                            <div class=' col-md-2 p-2 mx-auto'>
                                                <img
                                                    src='/assets/images/user.png'
                                                    width='50px'
                                                    alt=''
                                                    class='rounded-circle m-2 '
                                                />
                                            </div>
                                            <div class='col-md'>
                                                <div class='d-flex justify-content-between'>
                                                    <div>
                                                        <h4>{response.name}</h4>{' '}
                                                    </div>
                                                    <div className=''>
                                                        <AiFillCloseCircle
                                                            className='response-delete-icon'
                                                            onClick={() => deleteResponse(response.id)}
                                                        />
                                                    </div>
                                                </div>

                                                <p className='m-0 p-0 text-secondary'>
                                                    <MdEmail />
                                                    &nbsp;&nbsp;{response.email}{' '}
                                                </p>
                                                <hr />
                                                <p className='message-text px-3'>{response.message}</p>
                                                <hr />
                                                <p class='d-flex justify-content-end text-secondary'>
                                                    <small>
                                                        {response.submitOn
                                                            ? `${moment(
                                                                response.submitOn.seconds * 1000
                                                            ).format('LLL')}`
                                                            : 'no date provided'}
                                                    </small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ContactUsResponses;
